// Target origin must be this document's own origin, never '*'. Resolved at runtime
// so it stays correct across environments without a configured domain.
export const postToSelf = (payload: { key: string; message: string }): void => {
  window.postMessage(payload, window.location.origin);
};
